import { useNavigate } from "react-router-dom";
import { Form, Button, Card } from "antd";
import { createUseStyles } from "react-jss";
import { OutletData } from "../../../services/dto/outlet";
import TextInput from "../../../uiComponent/input/TextInput";
import SelectInput from "../../../uiComponent/input/SelectInput";
import { createOutletSubmitRequest } from "../utils";
import { endpoints } from "../../../services/endpoints/endpoints";

const useStyles = createUseStyles({
  container: {
    padding: "20px",
    background: "#fff",
    minHeight: "100vh",
  },
  card: {
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  formItem: {
    marginBottom: "15px",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  },
});

interface OutletInputProps {
  reviewRoute: string;
  title: string;
  initialData?: OutletData;
  action: string;
}

export function OutletInput({
  reviewRoute,
  title,
  initialData,
  action,
}: OutletInputProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const onFinish = (values: Record<string, any>) => {
    const request = createOutletSubmitRequest(action, values);
    navigate(`${reviewRoute}`, { state: { data: values, request: request } });
  };

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <h2>{title}</h2>
        <Form
          layout="horizontal"
          onFinish={onFinish}
          initialValues={initialData}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          labelAlign={"left"}
          colon={false}
        >
          <TextInput
            label="Kode"
            name="code"
            rules={[
              {
                required: true,
                message: "Tolong Input Nama Outlet ,Maksimal 40 karakter",
                max: 40,
              },
            ]}
            className={classes.formItem}
          />
          <TextInput
            label="Nama"
            name="name"
            rules={[
              {
                required: true,
                message: "Tolong Input Nama Outlet ,Maksimal 40 karakter",
                max: 40,
              },
            ]}
            className={classes.formItem}
          />
          <TextInput
            label="Alamat"
            name="address"
            rules={[
              {
                required: true,
                message: "Tolong Input Nama Outlet ,Maksimal 100 karakter",
                max: 100,
              },
            ]}
            className={classes.formItem}
          />
          <TextInput
            label="No. Telp"
            name="phoneNumber"
            className={classes.formItem}
            rules={[
              {
                required: true,
                message: "Tolong Input No Telp ,Maksimal 40 karakter",
                max: 40,
              },
            ]}
          />
          <SelectInput
            label={"Kota"}
            name={"city"}
            required={true}
            url={endpoints.outlet.getCity}
          />
          <TextInput
            label="Loc Id"
            name="locId"
            className={classes.formItem}
            rules={[
              {
                required: true,
                message: "Tolong Input Loc Id ,Maksimal 40 karakter",
                max: 40,
              },
            ]}
          />
          <TextInput
            label="Latidude"
            name="latidude"
            rules={[
              {
                required: true,
                message: "Tolong Input Latidude ,Maksimal 40 karakter",
                max: 40,
              },
            ]}
            className={classes.formItem}
          />
          <TextInput
            label="Longitude"
            name="longitude"
            rules={[
              {
                required: true,
                message: "Tolong Input longitude ,Maksimal 40 karakter",
                max: 40,
              },
            ]}
            className={classes.formItem}
          />

          <div className={classes.buttonsContainer}>
            <Button onClick={() => navigate("/outlet")} type="default">
              Back
            </Button>
            <Button type="primary" htmlType="submit">
              Confirm
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}
